export const operatorRoute = "partner";
export const operatorHome = `/${operatorRoute}/partner-home`;
export const operatorReverify = `/${operatorRoute}/partner-reverify`;
export const operatorSetUp = `/${operatorRoute}/partner-setup`;
export const operatorLanding = `/${operatorRoute}/:type/landing`;
export const operatorDashboard = `/${operatorRoute}/partner-dashboard`;
export const tempOnboardingOperator = `/${operatorRoute}/tempOnboarding-Operator`;
export const tempOnboardingOperatorTwo = `/${operatorRoute}/tempOnboarding-OperatorTwo`;
export const commonForm = `/${operatorRoute}/partner-pre-onboarding`;
export const commonOnBoardingForm = `/${operatorRoute}/partner-onboarding`;
export const operatorBusinessInfo = `/${operatorRoute}/partner-business-information`;
export const operatorBankTaxDetails = `/${operatorRoute}/partner-bank-tax-details`;
export const thankYou = `/${operatorRoute}/thankyou`;
export const operatorFaq = `/${operatorRoute}/partner-faq`;
export const cancellationPolicy = `/${operatorRoute}/cancellation-policy`;
export const addInventory = `/${operatorRoute}/add-inventory`;
export const loginAccount = `/${operatorRoute}/login-account`;
export const verifyLocationContact = `/${operatorRoute}/verify-loacation-contacts`;
export const contractVerification = `/${operatorRoute}/contract-verification`;
export const liveFleet = `/${operatorRoute}/live-fleet`;
export const bookingDetails = `/${operatorRoute}/motorcycle-details`;
export const bookingDetailsEdit = `/${operatorRoute}/booking-edit`;
export const pendingVerificationBulkUpload = `/${operatorRoute}/manage-motorcycle`;
export const addMotorcycles = `/${operatorRoute}/add-motorcycles`;
export const valueAddedServicesList = `/${operatorRoute}/value-added-servives-list`;
export const bookingsOperator = `/${operatorRoute}/bookings`;
export const transactions = `/${operatorRoute}/transactions`;
export const valueAddedServices = `/${operatorRoute}/value-added-servives`;
export const accountInfo = `/${operatorRoute}/account-info`;
export const manageAccountUser = `/${operatorRoute}/manage-account-user`;
export const editAccountUser = `/${operatorRoute}/edit-account-user`;
export const manageLocation = `/${operatorRoute}/manage-location`;
export const tripBookingDetails = `/${operatorRoute}/trip-booking-details`;
export const invoicesCreditNote = `/${operatorRoute}/invoices-credit-note`;
export const availableMotorcyclesList = `/${operatorRoute}/available-motorcycles-list`;
export const myProfile = `/${operatorRoute}/my-profile`;
export const ratingsReviews = `/${operatorRoute}/ratings-reviews`;
export const forgetPassword = `/${operatorRoute}/forgot-password`;
export const enterOTP = `/${operatorRoute}/enter-otp`;
export const resetPassword = `/${operatorRoute}/reset-password`;
export const invoiceDetails = `/${operatorRoute}/invoice-details`;
export const operatorCancellationPolicy = `/${operatorRoute}/terms-policy`;
export const dashboard = `/${operatorRoute}/dashboard`;
export const calendarDemo = `/${operatorRoute}/calander`;
export const ratingsReviews_details = `/${operatorRoute}/ratings-reviews-details`;
export const contractHistory = `/${operatorRoute}/contract-history`;
export const motorcycleDetails = `/${operatorRoute}/motorcycle-details`;
export const leadManagement = `/${operatorRoute}/lead-management`;
export const pendingLeadDetails = `/${operatorRoute}/pending-lead-details/:id`;
export const resourceManagement = `/${operatorRoute}/resource-management`;
export const support = `/${operatorRoute}/support`;
export const addNewTicket = `/${operatorRoute}/add-new-ticket`;
